import { createSelector } from 'reselect'

const getLabelsById = (state) => {
  return state['view-board'].labels.labelsById
}

const createSortedLabelsSelector = (getLabels) => createSelector(
  [getLabels, getLabelsById],
  (labels: any, labelsById) =>
    labels
      .map(id => labelsById[id])
      .sort((a, b) => a.position - b.position)
)

export default createSortedLabelsSelector
